import React from 'react';
import FirstApartament from './Components/FirstApartament';
import SecondApartament from './Components/SecondApartament';
import ThirdApartament from './Components/ThirdApartament';
import FourthApartament from './Components/FourthApartament';
import FifthApartament from './Components/FifthApartament';
import SixthApartament from './Components/SixthApartament';
import SeventhApartament from './Components/SeventhApartament';
import EighthApartament from './Components/EightApartament';
import NinethApartament from './Components/NinethApartament';

function Floor6() {

  return (
    <div className='w-[100vw] relative mt-40 mb-40  lg:h-auto'>
      <div className="w-[100vw] relative top-[50vw] lg:top-0 flex center">
        <img
          className='w-full'
          src="/images/click/clickable-images/Floors/Direct-floors/clean-floors/Floor6K5K6.jpg"
          alt=""
        />
        <>
          <FirstApartament />
          <SecondApartament />
          <ThirdApartament />
          <FourthApartament />
          <FifthApartament />
          <SixthApartament />
          <SeventhApartament />
          <EighthApartament />
          <NinethApartament />
        </>
      </div>
    </div>
  );
}

export default Floor6;
